import { Box, Card } from '@factorialco/deprecated-design-system'
import { EmployeeTimePeriodDetailsFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import AnnualBalanceTable from './AnnualBalanceTable'

interface Props {
  timePeriodDetails: EmployeeTimePeriodDetailsFragment[]
  loading: boolean
  convertHours: boolean
}

const AnnualBalance = ({ timePeriodDetails, loading, convertHours }: Props) => {
  const title = i18n.t('shift_management.time_insights.time_balance_content.annual_balance.title')
  const tooltip = i18n.t(
    'shift_management.time_insights.time_balance_content.annual_balance.tooltip'
  )

  return (
    <Card>
      <Card.Title tooltip={tooltip}>{title}</Card.Title>
      <Card.Content>
        <Box paddingY="s16">
          <AnnualBalanceTable
            timePeriodDetails={timePeriodDetails}
            loading={loading}
            convertHours={convertHours}
          />
        </Box>
      </Card.Content>
    </Card>
  )
}

export default observer(AnnualBalance)
